import React, { FC, useState } from 'react';
import { BundleProduct } from 'src/components/ProductDetail/utils/product-detail.types';
import { ModalProductInfo } from 'src/components/ProductDetail/ModalProductInfo';
import { DeliveryTab } from 'src/components/ProductDetail/DeliveryTab';
import { RichText } from 'src/components/RichText/RichText';
import { ProductMainPrice } from 'src/components/BundleProduct/ProductMainPrice';
import { MediaEntry, ProductPrice } from 'src/types/global-types';
import { SizeGuideLoader } from 'src/components/SizeGuide/SizeGuideLoader';
import { BundleConfig } from 'src/components/BundleProduct/types';
import { YotpoRating } from 'src/components/YotpoReviews/YotpoRating';

import { BrandLogoLink } from './BrandLogoLink';
import classes from './BundleInfo.scss';

type Props = {
    bundlePrice: ProductPrice;
    product: BundleProduct;
    sizeGuide: string;
    mediaEntry?: MediaEntry;
    bundles: BundleConfig[];
};

export const BundleInfo: FC<Props> = ({ product, bundlePrice, sizeGuide, mediaEntry, bundles }) => {
    const [isOpenProductInfoModal, setIsOpenProductInfoModal] = useState(false);
    const [firstPhoto] = product.media_entries || [];
    const wrapperStyles = {
        backgroundImage: `url(${firstPhoto.large_url})`,
    };
    const isMultipleBundle = bundles.length > 1;

    return (
        <div className={classes.wrapper} style={wrapperStyles}>
            <ModalProductInfo
                isOpenProductInfoModal={isOpenProductInfoModal}
                closeProductInfoModal={() => setIsOpenProductInfoModal(false)}
                description={product.description || ''}
                is24HourDelivery={product.is_24_hour_delivery}
                canCustomise={product.can_customise}
                mediaEntires={product.media_entries}
                productName={product.name}
                additionalMediaEntry={mediaEntry}
                delivery={<DeliveryTab />}
            />
            <div className={classes.info}>
                <BrandLogoLink
                    wrapperClassName={classes.link}
                    brandImage={product.brand_badge}
                    brandLink={`/brands/${product.brand_badge}`}
                    brandName={product.brand_badge}
                />
                <h1 className={classes.title}>{product.name}</h1>
                {isMultipleBundle ? (
                    <div className={classes.multipleTags}>
                        {bundles.map((bundle) => (
                            <div key={bundle.id} className={classes.whitePromo}>
                                <span>{`${bundle.maxQty} x ${bundle.bundleInformation?.name}`}</span>
                            </div>
                        ))}
                    </div>
                ) : (
                    <button type="button" className={classes.button} onClick={() => setIsOpenProductInfoModal(true)}>
                        <div className={classes.content}>
                            Product details
                            <div className={classes.icon} />
                        </div>
                    </button>
                )}
            </div>
            <div className={classes.prices}>
                {product.promo_banner && (
                    <div className={classes.promo}>
                        <RichText content={product.promo_banner} />
                    </div>
                )}
                {bundlePrice.final_price !== bundlePrice.regular_price && (
                    <div className={classes.regularPrice}>
                        <ProductMainPrice
                            price={{
                                price: bundlePrice.regular_price,
                                price_incl: bundlePrice.regular_price_incl,
                            }}
                        />
                    </div>
                )}
                <div className={classes.currentPrice}>
                    <ProductMainPrice
                        price={{
                            price: bundlePrice.final_price,
                            price_incl: bundlePrice.final_price_incl,
                        }}
                    />
                </div>
                <YotpoRating urlKey={product.url_key || ''} productId={product.id} />
                {sizeGuide && (
                    <div className={classes.sizeGuide}>
                        <SizeGuideLoader sizeGuide={sizeGuide} />
                    </div>
                )}
            </div>
        </div>
    );
};
